export enum ExperienceTypeID {
   RSVP = 1,
   Media = 2,
   Passbook = 3,
   App = 4,
   Email = 5,
   QRCode = 6,
   SMS = 7,
   WebReg = 8,
   JoinVirtual = 9
}

export enum AppDeviceID {
   Phone = 1,
   Tablet = 2
}

export interface Experience {
   id?:number;
   campaignId:number;
   type:ExperienceTypeID;
   modified?:string;
   isCustom?:boolean;
   settings:any; // should we go to the trouble of typing settings models?
}

export interface ExperienceTypeDef {
   id: ExperienceTypeID;
   label: string;
   slug: string;
   isWebsite?: boolean;
   mandrill_template?: string;
   email_name?: string;
   device?: AppDeviceID;
}

export interface ExperienceField {
   key:string;
   label:{[key:string]:string};
   placeholder:{[key:string]:string};
   type:string;
   required:boolean;
   // enabled:boolean; always true, no idea why this was ever in the data
   sizeX:number;
   sizeY:number;
   minSizeX:number;
   minSizeY:number;
   maxChoices?:number;
   value:string;
   row:number;
   col:number;
   labelAlignment:'left'|'center'|'right';
   surveyId?:number;
   tosKey:string;
   description:{[key:string]:string};
   infoURL:{[key:string]:string};
}
// TODO: Check these mandrill templates by name and decide if were going to update them
export const experienceTypeDefs:{[slug:string]:ExperienceTypeDef} = {
   passbook: {
      id: ExperienceTypeID.Passbook,
      label: 'Passbook',
      slug: 'passbook'
   },
   rsvp: {
      id: ExperienceTypeID.RSVP,
      label: 'RSVP Site',
      slug: 'rsvp',
      isWebsite: true
   },
   'thank-you-email': {
      id: ExperienceTypeID.Email,
      label: 'Thank You Email',
      mandrill_template: 'e360-env-thank-you-email',
      email_name: 'PostEventThankyou',
      slug: 'thank-you-email'
   },
   'sorry-email': {
      id: ExperienceTypeID.Email,
      label: 'Sorry Email',
      mandrill_template: 'e360-env-sorry-email',
      email_name: 'PostEventNotAttend',
      slug: 'sorry-email'
   },
   'registration-email': {
      id: ExperienceTypeID.Email,
      label: 'Registration Email',
      mandrill_template: 'e360-env-registration-email',
      email_name: 'Registration',
      slug: 'registration-email'
   },
   'qr-page': {
      id: ExperienceTypeID.QRCode,
      label: 'QR Page',
      slug: 'qr-page',
      isWebsite: true
   },
   'media-sms': {
      id: ExperienceTypeID.SMS,
      label: 'Media SMS',
      slug: 'media-sms'
   },
   'confirmation-email': {
      id: ExperienceTypeID.Email,
      label: 'Confirmation Email',
      mandrill_template: 'e360-env-confirmation-email',
      email_name: 'RsvpConfirm',
      slug: 'confirmation-email'
   },
   'invite-email': {
      id: ExperienceTypeID.Email,
      label: 'Invite Email',
      mandrill_template: 'e360-env-invite-email',
      email_name: 'RsvpInvite',
      slug: 'invite-email'
   },
   'friend-invite-email': {
      id: ExperienceTypeID.Email,
      label: 'Friend Invite Email',
      mandrill_template: 'e360-env-friend-invite-email',
      email_name: 'RsvpTellFriend',
      slug: 'friend-invite-email'
   },
   'guest-invite-email': {
      id: ExperienceTypeID.Email,
      label: 'Guest Invite Email',
      mandrill_template: 'e360-env-guest-invite-email',
      email_name: 'RsvpGuestInvite',
      slug: 'guest-invite-email'
   },
   'reminder-email': {
      id: ExperienceTypeID.Email,
      label: 'Reminder Email',
      mandrill_template: 'e360-env-reminder-email',
      email_name: 'RsvpReminder',
      slug: 'reminder-email'
   },
   'webinar-email': {
      id: ExperienceTypeID.Email,
      label: 'Join Link Email',
      mandrill_template: 'e360-env-webinar-email',
      email_name: 'WebinarReminder',
      slug: 'webinar-email'
   },
   'web-reg': {
      id: ExperienceTypeID.WebReg,
      label: 'Mobile Self-Registration',
      slug: 'web-reg',
      isWebsite: true
   },
   'join-virtual': {
      id: ExperienceTypeID.JoinVirtual,
      label: 'Join Virtual Page',
      slug: 'join-virtual',
      isWebsite: true
   },
   'app-phone': {
      id: ExperienceTypeID.App,
      device: 1,
      label: 'iPhone App',
      slug: 'app-phone'
   },
   'app-tablet': {
      id: ExperienceTypeID.App,
      device: 2,
      label: 'iPad App',
      slug: 'app-tablet'
   },
   'media-page': {
      id: ExperienceTypeID.Media,
      label: 'Media Page',
      slug: 'media-page',
      isWebsite: true
   },
   'media-email': {
      id: ExperienceTypeID.Email,
      label: 'Media Email',
      mandrill_template: 'e360-env-media-email',
      email_name: 'Media',
      slug: 'media-email'
   }
};
